import { jsx as v } from "react/jsx-runtime";
const c = (h) => /* @__PURE__ */ v(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 24",
    ...h,
    children: /* @__PURE__ */ v(
      "path",
      {
        fill: "currentcolor",
        d: "M30.189 19.416V4.584H32v14.832zM26.886 17.074c-1.56 0-2.295-.874-2.295-2.31v-4.091h-1.155V8.956h1.155V6.739h2.14v2.217h1.732v1.717H26.73v3.934c0 .531.203.75.765.75h.859v1.717zM20.44 12.952l2.842 4.122h-2.233l-1.686-2.53-1.686 2.53h-2.233l2.842-4.122-2.732-3.996h2.2l1.609 2.404 1.608-2.404h2.201zM11.548 17.261c-2.295 0-3.778-1.342-3.778-3.622v-1.108c0-2.202 1.311-3.763 3.746-3.763 2.405 0 3.622 1.608 3.622 3.56v1.42H9.83v.204c0 .952.484 1.78 1.718 1.78.905 0 1.467-.47 1.67-1.031h1.858c-.281 1.483-1.733 2.56-3.528 2.56m-1.718-5.09v.079h3.357v-.203c0-1.015-.53-1.78-1.67-1.78-1.218 0-1.687.812-1.687 1.905M5.45 17.074c-1.56 0-2.295-.874-2.295-2.31v-4.091H2V8.956h1.155V6.739h2.14v2.217h1.732v1.717H5.294v3.934c0 .531.203.75.765.75h.859v1.717z"
      }
    )
  }
);
export {
  c as default
};
